import { spacer8 } from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';
import { MD_GRID_MAX_WIDTH, TWO_COLUMN_MAX_WIDTH, ONE_COLUMN_MAX_WIDTH, } from '../Grid';
export const FullWidthLayout = styled.ul `
  --number-of-vids-to-show: ${({ numberOfVideosToShow }) => numberOfVideosToShow};
  // gap between each video
  --gap: 8px;
  // for full bleed, affordance video is
  //grid padding  - gap size
  // grid padding on lg screen is 48px
  --affordance-video-width: 40px;
  display: flex;
  flex-direction: row;
  padding-inline-start: 0px;
  gap: ${spacer8};
  height: 100%;

  // we want to display number of videos with one extra showing on each side cut off
  // 100% of layout width within the grid = NV + (N - 1)(gap)
  // where N is the number of videos, V is the width of each video, and gap is the gap between the videos

  width: calc(
    100% + 2 *
      (
        (
            (100% - (2 * var(--affordance-video-width)) - var(--gap)) /
              var(--number-of-vids-to-show)
          ) - var(--gap) - var(--affordance-video-width)
      )
  );

  // have to shift the videos over so the right amount of affordance video shows
  margin-inline-start: calc(
    -1 * ((
            (100% - (2 * var(--affordance-video-width)) - var(--gap)) /
              var(--number-of-vids-to-show)
          ) - var(--gap) - var(--affordance-video-width))
  );

  @media (max-width: ${MD_GRID_MAX_WIDTH}) {
    // grid padding on md screen is 40px
    --affordance-video-width: 32px;
    width: calc(
      100% + 2 *
        (
          (
              (100% - (2 * var(--affordance-video-width)) - var(--gap)) /
                var(--number-of-vids-to-show)
            ) - var(--gap) - var(--affordance-video-width)
        )
    );

    margin-inline-start: calc(
      -1 * ((
              (100% - (2 * var(--affordance-video-width)) - var(--gap)) /
                var(--number-of-vids-to-show)
            ) - var(--gap) - var(--affordance-video-width))
    );
  }
`;
export const CompactLayout = styled.div `
  --num-videos: ${({ numVideos }) => numVideos};

  // gap between each video
  --gap: 8px;
  display: flex;
  padding-inline-start: 0px;
  flex-direction: row;
  gap: ${spacer8};
  height: 100%;

  // on large screens the videos scale proportionaly to maintain square aspect ratio
  // video width is 60%
  width: calc(
    (60% * var(--num-videos)) + ((var(--num-videos) - 1) * var(--gap))
  );
  margin-inline-start: calc((100% + (2 * var(--gap))) / -1);

  // half of affordance videos shows on two column width
  // video width is 50% of total width - gap
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    width: calc(
      ((50% - var(--gap)) * var(--num-videos)) +
        ((var(--num-videos) - 1) * var(--gap))
    );
    margin-inline-start: calc(((50% - var(--gap)) * 1.5 + var(--gap)) / -1);
  }

  // video width is 75% of total width
  // affordance video width is (25% - 8px*2) / 2
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    width: calc(
      (75% * var(--num-videos)) + ((var(--num-videos) - 1) * var(--gap))
    );
    margin-inline-start: calc(
      (75% + (75% - (25% - (var(--gap) * 2)) / 2) + var(--gap)) * -1
    );
  }

  ${({ scrollAnimation }) => scrollAnimation &&
    css `
      animation-name: ${scrollAnimation};
      animation-duration: 0.5s;
      animation-iteration-count: 1;
      animation-timing-function: cubic-bezier(0.75, 0, 0, 1);

      @keyframes right {
        to {
          -webkit-transform: translateX(calc((-100% / var(--num-videos))));
        }
      }
      @keyframes left {
        to {
          -webkit-transform: translateX(calc((-100% / var(--num-videos) * -1)));
        }
      }
    `}
`;
//# sourceMappingURL=Layout.js.map